import { Icon } from "@blueprintjs/core"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import CustomTag from "components/Atoms/CustomTag"
import { SELECT_ALL_ROWS } from "store/selector.redux"
import useSelectionActive from "./useSelectionActive"
import useAuth from "hooks/useAuth"
const DemandSelectorAll = ({ demands }) => {
  const isSelectionActive = useSelectionActive()
  const isSelectAllActive = useSelector(
    (state: any) => state?.selector?.demands?.selectAll
  )
  const dispatch = useDispatch()
  const me = useAuth()
  const demandWhatsappApproval =
    me?.user?.currentDepartment?.demandWhatsappApproval

  const parsedDemands = demands
    ?.filter(val => demandWhatsappApproval && val?.isVerified)
    ?.map(d => ({ id: d?.id, name: d?.name, isVerified: d?.isVerified }))

  /**
   * Basically, show select all when the user in is selection mode and selectAll is off already
   */
  const selectAll = isSelectionActive && !isSelectAllActive

  return (
    <>
      {isSelectionActive && (
        <div className="vt-demand-filter-tags px-3 mt-3">
          <CustomTag
            interactive
            onClick={e => {
              dispatch({
                path: "demands",
                type: SELECT_ALL_ROWS,
                payload: parsedDemands,
              })
            }}
            intent={selectAll ? "success" : "danger"}
            minimal
            icon={<Icon icon={selectAll ? "plus" : "minus"} />}
          >
            {selectAll ? "Select All" : "De-select all"}
          </CustomTag>
        </div>
      )}
    </>
  )
}

export default DemandSelectorAll
